
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowRight, BookOpen, Route } from 'lucide-react';
import Header from './components/Header';
import Hero from './components/Hero';
import MissionVision from './components/MissionVision';
import HowItWorks from './components/HowItWorks';
import PremiumExperiences from './components/PremiumExperiences';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  const location = useLocation();
  const { i18n } = useTranslation();
  const en = i18n.resolvedLanguage?.startsWith('en');

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      {location.pathname === '/' && <section className="bg-[#0A1628] px-5 pb-16 pt-10 text-white sm:px-8 sm:pb-20" aria-labelledby="passport-paths-heading">
        <div className="mx-auto max-w-6xl">
          <p className="text-xs font-semibold uppercase text-[#E8D4A0]">Aero Passport</p>
          <h2 id="passport-paths-heading" className="mt-3 max-w-2xl text-3xl font-bold leading-tight sm:text-4xl">{en ? 'Plan the next journey. Keep the stories from the last.' : 'Planeje a próxima viagem. Guarde as histórias da anterior.'}</h2>
          <div className="mt-8 grid border-t border-white/15 md:grid-cols-2 md:divide-x md:divide-white/15">
            <div className="border-b border-white/15 py-7 md:border-b-0 md:pr-10">
              <Route className="text-[#E8D4A0]" size={27} aria-hidden="true" />
              <h3 className="mt-4 text-xl font-bold">{en ? 'Plan a new trip' : 'Planeje uma nova viagem'}</h3>
              <p className="mt-2 max-w-md text-sm leading-relaxed text-white/70">{en ? 'Our AI turns your travel preferences into a traveler profile and tailored itinerary, refined by our travel team.' : 'Nossa IA transforma suas preferências em um perfil de viajante e um roteiro personalizado, refinado por nossa equipe.'}</p>
              <a href="#contact" className="mt-5 inline-flex min-h-11 items-center gap-2 font-semibold text-[#E8D4A0] hover:text-white">{en ? 'Create an itinerary' : 'Criar um roteiro'}<ArrowRight size={17} aria-hidden="true" /></a>
            </div>
            <div className="py-7 md:pl-10">
              <BookOpen className="text-[#89C8C3]" size={27} aria-hidden="true" />
              <h3 className="mt-4 text-xl font-bold">{en ? 'Open your travel passport' : 'Abra seu passport de viagens'}</h3>
              <p className="mt-2 max-w-md text-sm leading-relaxed text-white/70">{en ? 'A companion for your flights, saved places, notes and travel memories. Revisit your passports without starting a new itinerary.' : 'Um companheiro para seus voos, lugares salvos, notas e memórias de viagem. Revisite seus passports sem começar um novo roteiro.'}</p>
              <Link to="/app/login?next=%2Fapp%2Fdashboard" className="mt-5 inline-flex min-h-11 items-center gap-2 font-semibold text-[#89C8C3] hover:text-white">{en ? 'Go to Aero Passport' : 'Ir para o Aero Passport'}<ArrowRight size={17} aria-hidden="true" /></Link>
            </div>
          </div>
        </div>
      </section>}
      <MissionVision />
      <HowItWorks />
      <PremiumExperiences />
      <Contact />
      <Footer />
    </div>
  );
}
